import { uniqBy } from "lodash"
import {
  GET_BUSINESS_COLOR_PALETTES_SUCCESS,
  GET_PUBLIC_COLOR_PALETTES_SUCCESS,
  GET_COLOR_PALETTE_SUCCESS,
  POST_COLOR_PALETTE_SUCCESS,
  RESET_POSTED_COLOR_PALETTE,
} from "Containers/ColorPalettes/types"

const initialState = {
  publicColorPalettes: [],
  businessColorPalettes: [],
  selectedColorPalette: {},
  postedColorPalette: {},
  paletteV2: false,
}

function colorPalettesReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_BUSINESS_COLOR_PALETTES_SUCCESS:
      if (payload.paletteV2) {
        return {
          ...state,
          paletteV2: true,
          businessColorPalettes: payload.body,
        }
      } else {
        if (!state.paletteV2) {
          return {
            ...state,
            paletteV2: false,
            businessColorPalettes: payload.body,
          }
        } else {
          return {
            ...state,
          }
        }
      }
    case GET_PUBLIC_COLOR_PALETTES_SUCCESS:
      return {
        ...state,
        publicColorPalettes: payload.body,
      }
    case GET_COLOR_PALETTE_SUCCESS:
      return {
        ...state,
        selectedColorPalette: payload.body,
      }
    case POST_COLOR_PALETTE_SUCCESS:
      return {
        ...state,
        postedColorPalette: payload.body,
      }
    case RESET_POSTED_COLOR_PALETTE:
      return {
        ...state,
        postedColorPalette: {},
      }
    default:
      return state
  }
}

export default colorPalettesReducer
